import StopCircleIcon from "@mui/icons-material/StopCircle";
import IconButton from "@mui/material/IconButton";
import dayJs from "dayjs";
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import React from "react";
import { useFormContext } from "react-hook-form";

import { UpdateTaskPropInterface } from "./StopTask";

import { CreateTaskInterface } from "@/types/task";

dayJs.extend(utc);
dayJs.extend(timezone);

export const StopTask: React.FC<UpdateTaskPropInterface> = ({ isLoading }) => {
  const { setValue } = useFormContext<CreateTaskInterface>();

  return (
    <IconButton
      color="primary"
      onClick={() => setValue("endTime", dayJs().tz().format())}
      disabled={isLoading}
      type="submit"
    >
      <StopCircleIcon sx={{ fontSize: "3rem" }} />
    </IconButton>
  );
};
